import {AfterContentInit, ChangeDetectorRef, Component, Input, OnChanges, signal, SimpleChanges} from '@angular/core';
import {FunctionInfoModel, ReportRoute, RoutPostModel} from '../../../../Api/DcoApi/Reporting/ReportRoute';
import {RestClient} from '../../../../Api/DcoApi/Client/RestClient';
import {Report} from '../../../../Api/DcoApi/Reporting/Report';
import {DataGridView, DataGridViewCollumn} from '../../../../Componente/DataGridView';
import {PopUpView} from '../../../../Componente/PopUpView';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ReportDesigner} from '../../report-designer/report-designer';
import {FunctionParameter, FunctionParameterGroup} from '../../../../Api/DcoApi/Reporting/FunctionParameter';
import {NgbInputDatepicker} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-route-edit',
  imports: [
    DataGridView,
    DataGridViewCollumn,
    PopUpView,
    ReactiveFormsModule,
    ReportDesigner,
    FormsModule,
    NgbInputDatepicker
  ],
  templateUrl: './route-edit.html',
  styleUrl: './route-edit.css',
})
export class RouteEdit implements AfterContentInit, OnChanges{
    ngOnChanges(changes:SimpleChanges): void {
      if (changes['Route']) {

        this.IsNew.set(this.Route.key === 0);
      }
    }

    @Input() ReportID: number = 0;
    @Input() Route: ReportRoute = { key: 0 } as ReportRoute;
    IsNew =signal(this.Route.key === 0);
    ApiClient: RestClient = new RestClient();
    ReportInfo: FunctionParameter[] = [];
    FunctionInfoItems = signal<FunctionInfoModel[]>([]);
    FunctionsList = signal<FunctionParameterGroup[]>([])
    constructor(private ref: ChangeDetectorRef) {}

    FunctionsListGroup = () => {
      var result: FunctionParameterGroup[] = [];

      this.ReportInfo.forEach(p => {
        var entry = result.find(o => o.functionName === p.functionName);
        if(entry === undefined){
          entry = { functionName: p.functionName, parameters: [] };
          result.push(entry);
        }
        entry.parameters.push(p);
      });

      return result;
    };

  async SaveData() {
    if(this.IsNew())
      this.Route = await this.ApiClient.Put<ReportRoute,RoutPostModel>(`/Backend/Api/V2/ReportAdmin/${this.ReportID}/Route`, { route: this.Route.urlExpression } as RoutPostModel);
    else {
      this.Route = await this.ApiClient.Post<ReportRoute, RoutPostModel>(`/Backend/Api/V2/ReportAdmin/${this.ReportID}/Route/${this.Route.key}`, { route: this.Route.urlExpression } as RoutPostModel);
    }

    this.IsNew.set(this.Route.key === 0);
    this.ref.detectChanges();
  }

  ChangeDefaultValue(data:string | undefined,param:FunctionParameter)
  {
    var item = this.FunctionInfoItems().find(o => o.functionName === param.functionName && o.parameter === param.parameter && o.datasource === param.datasource);
    if(item !== undefined)
    {
      item.defaultValue = data;
      this.saveParameter(item);
    }
  }

  LoadUrlPart(param:FunctionParameter) : string | null | undefined{
    var item = this.FunctionInfoItems().find(o => o.functionName === param.functionName && o.parameter === param.parameter && o.datasource === param.datasource);
    return item?.querryString;
  }

  ChangeUrlPart(data:string | undefined,param:FunctionParameter)
  {
    var item = this.FunctionInfoItems().find(o => o.functionName === param.functionName && o.parameter === param.parameter && o.datasource === param.datasource);
    if(item !== undefined)
    {
      item.querryString = data;
      this.saveParameter(item);
    }
  }

  LoadDefaultValue(param:FunctionParameter) : string | null | undefined{
    var item = this.FunctionInfoItems().find(o => o.functionName === param.functionName && o.parameter === param.parameter && o.datasource === param.datasource);
    return item?.defaultValue;
  }


  async saveParameter(param:FunctionInfoModel) {
    await this.ApiClient.Post<any, FunctionInfoModel>(`/Backend/Api/V2/ReportAdmin/${this.ReportID}/SetParameter/${ this.Route.key}`, param);
  }


  async ngAfterContentInit() {
    this.ReportInfo = await this.ApiClient.Get<FunctionParameter[]>(`/Backend/Api/V2/ReportAdmin/${this.ReportID}/ParameterListe`);
    this.FunctionsList.set(this.FunctionsListGroup());
    var data:FunctionInfoModel[] = [];

    this.ReportInfo.forEach(i => {
      var currentEntry = this.Route.filterEntries.find(o => o.function === i.functionName && o.property == i.parameter && o.dataSource === i.datasource);
      if(currentEntry){
        data.push({ functionName: i.functionName, parameter: i.parameter, datasource: i.datasource, defaultValue: currentEntry.defaultValue, querryString: currentEntry.urlEntry });
      }
      else {
        data.push({ functionName: i.functionName, parameter: i.parameter, datasource: i.datasource });
      }
    })

    this.FunctionInfoItems.set(data);
    this.IsNew.set(this.Route.key === 0);
  }

}
